import { render, staticRenderFns } from "./CustomDrawer.vue?vue&type=template&id=c0d28abc&scoped=true"
import script from "./CustomDrawer.vue?vue&type=script&lang=js"
export * from "./CustomDrawer.vue?vue&type=script&lang=js"
import style0 from "./CustomDrawer.vue?vue&type=style&index=0&id=c0d28abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d28abc",
  null
  
)

export default component.exports